module.exports = __webpack_public_path__ + "static/img/compony.21db278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/compony.png
// module id = 5TZl
// module chunks = 1